export enum CalendarDimensions {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}
